var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmail = function SvgEmail(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 16",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 2H3C1.9 2 1 2.9 1 4V12C1 13.1 1.9 14 3 14H17C18.1 14 19 13.1 19 12V4C19 2.9 18.1 2 17 2ZM17 4L10 8.5L3 4H17ZM17 12H3V5.5L10 10L17 5.5V12Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmail);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyMCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiA+CiAgPHBhdGggZD0iTTE3IDJIM0MxLjkgMiAxIDIuOSAxIDRWMTJDMSAxMy4xIDEuOSAxNCAzIDE0SDE3QzE4LjEgMTQgMTkgMTMuMSAxOSAxMlY0QzE5IDIuOSAxOC4xIDIgMTcgMlpNMTcgNEwxMCA4LjVMMyA0SDE3Wk0xNyAxMkgzVjUuNUwxMCAxMEwxNyA1LjVWMTJaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+";